import React from 'react'
import { Modal, Button } from 'semantic-ui-react'
import { Form } from 'formsy-semantic-ui-react';
import { singleLineText, multiLineText } from './RegexValidation';

var moment = require('moment');
class EditTextModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formcyButtonDisabled: false
        }
    }

    close = (e) => {
        this.props.openTextModal(e, false, null, null);
    }

    buttonDisabled = (e, set) => {
        this.setState({ formcyButtonDisabled: set });
    }


    render() {
        const errorLabel = <div className="customErrorLabel" />;
        return (
            <Modal
                className="basicModal "
                open={this.props.open}
                size='tiny'
                closeOnEscape={false}
                closeOnDimmerClick={false}
                onClose={this.close} 
                closeIcon
            >
                {/* <Modal.Header>{this.props.headerName ? this.props.headerName : this.props.name}</Modal.Header> */}
                <Modal.Header>Edit {this.props.name}</Modal.Header>
                <Modal.Content>
                    <Form noValidate
                        ref={ref => this.form = ref}
                        className="formcyForm"
                        onValid={(e) => this.buttonDisabled(e, true)}
                        onInvalid={(e) => this.buttonDisabled(e, false)}
                        onValidSubmit={(e) => { this.props.submitTextModal(e) }}
                    >

                        <Form.Input
                            required
                            name={this.props.name}
                            id={this.props.name}
                            label={this.props.name}
                            value={this.props.text}
                            placeholder=""
                            validations={{ matchRegexp: singleLineText }}
                            errorLabel={errorLabel}
                            validationErrors={{
                                matchRegexp: 'Max limit is 128.',
                                isDefaultRequiredValue: `${this.props.name} is required`,
                            }}
                            onChange={(e) => {
                                this.props.onChangeText(e.target.value, this.props.name)
                            }}
                            instantValidation
                            autoFocus={this.props.autoFocus ? this.props.autoFocus : null}
                        />
                        {this.props.descriptionNeeded &&
                            <Form.TextArea
                                name="description"
                                label="Description"
                                id="description"
                                value={this.props.description}
                                errorLabel={errorLabel}
                                validations={{ matchRegexp: multiLineText }}
                                validationErrors={{
                                    matchRegexp: 'Max limit is 512. No space allowed in starting.',
                                    isDefaultRequiredValue: 'Description is required.',
                                }}
                                instantValidation
                            />
                        }
                        {
                            this.props.error ?
                                <span className='clr-red'>
                                    {this.props.name} with same name already exists.  {/* Changes made for KLM-9072 */}
                                </span>
                                : null
                        }
                        <br />
                        <div className="pull-right" style={{ "marginBottom": "25px" }}>
                            <Button content='Cancel' className="button-cancel" type="button" onClick={this.close} />
                            <Button disabled={this.props.error || !this.state.formcyButtonDisabled} onClick={this.props.submitTextModal} type="submit" content='Update' className="button-submit" />
                        </div>
                    </Form >

                </Modal.Content>

            </Modal>
        )
    }
}

export default EditTextModal;